const handleReturnToTop = () => {   
    const returnToTopButton = document.querySelector('.scroll-to-top') ?? '';

    if (returnToTopButton) {
        returnToTopButton.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        });
    } else {
        return;
    }  
};

export default handleReturnToTop;